var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.264 7.778 14.02 3.536a1 1 0 0 0-1.414 0l-7.071 7.07a1 1 0 0 0 0 1.415l4.242 4.243a1 1 0 0 0 1.414 0l7.072-7.072a1 1 0 0 0 0-1.414m-2.829-5.657a3 3 0 0 0-4.243 0l-7.07 7.071a3 3 0 0 0 0 4.243l4.242 4.243a3 3 0 0 0 4.243 0l7.07-7.071a3 3 0 0 0 0-4.243z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.435 12.163 9.071 5.799l1.414-1.414 6.364 6.364zM2 21c0-.552.497-1 1.111-1H20.89c.614 0 1.111.448 1.111 1s-.497 1-1.111 1H3.11C2.497 22 2 21.552 2 21",
  clipRule: "evenodd"
})));
export default SvgIcClear;